import { showStatus } from './AxiosReqs';

export const navSearch = async function (toSearch) {
  if (toSearch.trim() === '') {
    return showStatus('fail', 'Search is empty');
  }

  window.location.href = `/search/${toSearch.trim()}`;
};
